import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import { Box, Stack } from "@mui/system";

export const StackContainer = styled(Grid)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(5),
}));

export const ChatBoxWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  height: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const ChatContainer = styled(Stack)(({ theme }) => ({
  overflowX: "auto",
  maxWidth: "100%",
  display: "flex",
  "&::-webkit-scrollbar": { display: "none" },
}));

export const MainGrid = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "isHistoryOpen",
})<{ isHistoryOpen: boolean }>(({ theme, isHistoryOpen }) => ({
  padding: theme.spacing(3),
  paddingTop: theme.spacing(1),
  paddingLeft: isHistoryOpen ? theme.spacing(5) : theme.spacing(20),
  display: "flex",
  flex: 1,
  flexDirection: "column",
  height: "100%",
  minHeight: 0,
  overflow: "hidden",
  transition: "max-width 0.5s ease, flex-basis 0.5s ease",
}));
